import CompositeComponent from './CompositeComponent';
export default CompositeComponent;
